/* SafeRichText — formatting for admin rich text (booking-detail-reskin 6.3).
   Colors come from the injected per-tenant theme tokens only. */
.richText {
  /* The website's pieces size it from their own layer through these (web-studio-sites D6: shared
     components keep their unlayered CSS, which outranks a layered class on the same element);
     the app sets neither. */
  font-size: var(--rich-text-size, 13.5px);
  color: var(--text-secondary);
  line-height: var(--rich-text-leading, 1.55);
  /* A pasted link or other unbroken run wraps instead of pushing a phone page sideways. */
  overflow-wrap: anywhere;
}
.richText p {
  margin: 0;
}
.richText p + p {
  margin-top: 8px;
}
.richText strong,
.richText b {
  color: var(--text-primary);
  font-weight: 600;
}
.richText ul,
.richText ol {
  margin: 6px 0;
  padding-left: 20px;
}
.richText li {
  margin-bottom: 4px;
}
.richText a {
  color: var(--accent-hot);
  text-decoration: underline;
  text-underline-offset: 2px;
}
